import React, { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import "./app.scss";
import Spinner from "../Spinner/Spinner";

interface BasicApiResponse<T> {
  data: { [k: number]: T };
  message: string;
  messageCode: string | null;
  status: "success" | "failure";
}

interface Hgw {
  bridge: {
    set: boolean;
  };
  id: number;
}

enum AppStatus {
  Loading,
  NoHgwFound,
  Success,
  Error,
}

const App = ({ siteId }: { siteId: number }) => {
  const [status, setStatus] = useState(AppStatus.Loading);
  const [hgw, setHgw] = useState({} as Hgw);
  const [customerName, setCustomerName] = useState('');

  useEffect(() => {
    const user = Cookies.getJSON("user");
    if (user) {
      setCustomerName(user.customerName);
    }

    fetchHgw();

    async function fetchHgw() {
      try {
        const hgwRes: BasicApiResponse<Hgw> = await fetch(`/api/wifi/getwifibylocation?siteid=${siteId}`).then((r) =>
          r.json()
        );

        if (hgwRes.status === "success") {
          setHgw(hgwRes.data[siteId]);
          setStatus(AppStatus.Success);
        } else {
          throw hgwRes.messageCode;
        }
      } catch (e) {
        if (e === "LOGICAL_DEVICE_NOT_FOUND") {
          setStatus(AppStatus.NoHgwFound);
        } else {
          setStatus(AppStatus.Error);
        }
      }
    }
  }, [siteId, setHgw, setStatus]);

  const setBridgemode = async () => {
    const updatedBridge = { ...hgw.bridge, set: true };
    setStatus(AppStatus.Loading);

    try {
      const updateRes: BasicApiResponse<Hgw> = await fetch(`/api/wifi/updatewififorlocation?siteid=${siteId}1`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `data=${JSON.stringify({ ...hgw, bridge: updatedBridge })}`,
      }).then((r) => r.json());

      if (updateRes.status === "success") {
        setHgw(updateRes.data[hgw.id]);
        setStatus(AppStatus.Success);
      } else {
        throw updateRes;
      }
    } catch (e) {
      setStatus(AppStatus.Error);
    }
  };

  switch (status) {
    case AppStatus.Loading:
      return <Spinner />;
    case AppStatus.NoHgwFound:
      return <h2 className="text-center">Finner ingen hjemmesentral på den valgte lokasjonen.</h2>;
    case AppStatus.Error:
      return <h2 className="text-center">Noe gikk galt. Prøv igjen senere.</h2>;
    case AppStatus.Success:
      return <>
        {customerName && <p><span className="loggedInAs">Logget inn på Mine sider som: </span>{customerName}</p>}
        <div className="text-center">
          {hgw.bridge.set && <h2 role="alert" className="bridgemodeIsSet">Bromodus er satt.</h2>}
          {!hgw.bridge.set && <button id="wp-setBridgemode" onClick={setBridgemode}>Sett i bromodus</button> }
        </div>
      </>
  }
};

export default App;
